import { Auth } from '@auth/core';
import { createAuthConfig } from './createAuthConfig';
import { getTenantNameFromUrl, isUrlDev } from '@frontend/utils/tenant';

export type Tenant = {
	tenantName: string;
	isDevRoute: boolean;
};

export type AuthRequestOpts = {
	basePath?: string;
	tenant?: Tenant;
};

export const createAuthRequest = (req: Request, opts?: AuthRequestOpts) => {
	return Auth(
		req,
		createAuthConfig({
			basePath: opts?.basePath,
			authority: createAuthorityFromUrl(req.url, opts?.tenant).url,
		}),
	);
};

export const createAuthorityUrl = (tenantName: string, isDevRoute: boolean) =>
	`https://auth${isDevRoute ? '.dev.' : '.'}resani.com/realms/${tenantName}`;

export const createAuthorityFromUrl = (url: string, tenant?: Tenant) => {
	const tenantName = tenant?.tenantName ?? getTenantNameFromUrl(url);
	const isDevRoute = tenant ? tenant.isDevRoute : isUrlDev(url);

	const x = createAuthorityUrl(tenantName, isDevRoute);

	return {
		url: x,
		tenantName,
		isDevRoute,
	};
};
